import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import InstaTable from './InstaTable'
import FeedbackPreview from './FeedbackPreview'

import {
  feedback_index,
  templates_select,
  mark_read_feedback,
  mark_unread_feedback,
  mark_resolved_feedback,
  set_path
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals, feedback, fetching_index, fetched_index } = state.feedback
  return {
    fetching_index: fetching_index,
    fetched_index: fetched_index,
    feedback: feedback,
    feedbacks: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    templates: state.template.select_items,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getFeedbacks: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( feedback_index(page, per_page, filters, sort, order) ),
    getTemplates: () => dispatch( templates_select() ),
    markRead: (feedback_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(mark_read_feedback(feedback_id, index, page, per_page, filters, sort, order)),
    markUnread: (feedback_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(mark_unread_feedback(feedback_id, index, page, per_page, filters, sort, order)),
    markResolved: (feedback_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(mark_resolved_feedback(feedback_id, index, page, per_page, filters, sort, order)),
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedFeedbackIndex extends React.Component {
  state={
    current_feedback: {},
    current_view: 'all',
    merge_filters: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if (field === "status") {
      renderText = this.statusIcon(item[field])
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'test_id') {
      renderText = (
        <Link to={`/tests/test?test=${item.test_id}`} className="test_results_link" title="Test Results" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          {item.test_id}
        </Link>
      )
    } else if (field === "user_email") {
      renderText = (
        <Link to={`/users/${item.user.id}/edit`} target="_blank" className="test_results_link" title="Edit User" onClick={e => {
          e.stopPropagation()
        }}>
          <div className="td-user-email">{item.user.email}</div>
          <div className="td-user-name">{item.user.name}</div>
        </Link>
      )
    } else if (field === "template_name") {
      renderText = item.template.name
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { item.status !== "unread" && this.markUnreadLink(item, state) }
          { item.status !== "read" && this.markReadLink(item, state) }
          { item.status !== "resolved" && this.markResolvedLink(item, state) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getTemplates, getFeedbacks } = this.props
    getTemplates()
    getFeedbacks()
    this.props.setPath('feedback')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.fetching_index && !this.props.fetching_index && this.props.fetched_index) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else if (value === 'read') {
      this.setState({merge_filters: {status: 'read'}})
    } else if (value === 'unread') {
      this.setState({merge_filters: {status: 'unread'}})
    } else if (value === 'resolved') {
      this.setState({merge_filters: {status: 'resolved'}})
    } else {
      return
    }
    this.setState({current_view: value})
  }

  markReadLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Mark Read" onClick={e=>{
        e.preventDefault()
        this.props.markRead(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>drafts</Icon>
      </Link>
    )
  }

  markUnreadLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Mark Unread" onClick={e=>{
        e.preventDefault()
        this.props.markUnread(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>email</Icon>
      </Link>
    )
  }

  markResolvedLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Mark Resolved" onClick={e=>{
        e.preventDefault()
        this.props.markResolved(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
      </Link>
    )
  }

  hideDialog() {
    this.setState({showPreview: false, current_feedback: {}})
  }

  clearFeedback() {
    return
  }

  statusIcon = status => {
    if (status === 'read') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Read">drafts</Icon>
    } else if (status === 'unread') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Unread">email</Icon>
    } else if (status === 'resolved') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Resolved">check_circle</Icon>
    }
  }

  // P I C K PICK FROM HERE P I C K //
  showPreview = item => {
    this.setState({showPreview: true, current_feedback: item})
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { feedbacks, pagination, templates, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'created_at', disablePadding: true, label: 'Date' },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'user_email', disablePadding: true, label: 'Test Taker' },
      { id: 'template_name', disablePadding: true, label: 'Template' },
      { id: 'test_id', disablePadding: true, label: 'Instance',  disableSort: true },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "template", filter_type: "select", valueField: "name", collection: templates },
      { name: "search", filter_type: "search" },
      { name: "created_at", filter_type: "date" }
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "unread", label: "Unread", value: totals.unread },
      { name: "read", label: "Read", value: totals.read },
      { name: "resolved", label: "Resolved", value: totals.resolved },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.feedback.fetching_index ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Feedback Overview
          </Typography>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={feedbacks}
          pagination={pagination}
          role={role}
          search={true}
          previewColumn="id"
          previewItem={this.showPreview.bind(this)}
          clearItem={this.props.clearFeedback}
          placeholders="ID, Test Taker"
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getFeedbacks.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          previewColumns={{user_email: 'edit', test_id: 'insert_chart'}}
          classPrefix="feedback"
          addClassField="status"
        />

        <FeedbackPreview
          id="preview-template-dialog"
          isopen={this.state.showPreview}
          feedback_id={this.state.current_feedback.id}
          handleClose={this.hideDialog.bind(this)}
        />
      </div>
    )
  }
}

const FeedbackIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedFeedbackIndex)

export default withStyles(styles)(FeedbackIndex)



// WEBPACK FOOTER //
// ./src/js/components/FeedbackIndex.js